import { render, staticRenderFns } from "./ChatroomCurrentTicket.vue?vue&type=template&id=10959f92&scoped=true&"
import script from "./ChatroomCurrentTicket.vue?vue&type=script&lang=js&"
export * from "./ChatroomCurrentTicket.vue?vue&type=script&lang=js&"
import style0 from "./ChatroomCurrentTicket.vue?vue&type=style&index=0&id=10959f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10959f92",
  null
  
)

export default component.exports